//import Vuex from 'vuex'
//Vue.use(Vuex)
import Carousel from '../views/Home'

let JsppUI = {};
JsppUI.install = function (Vue){
	Vue.componment(Carousel.name,Carousel);
}

export default JsppUI;